const Cenefa = ({ title, alignClass }) => {
    return (
        <div className="Cenefa">
            <h1 className={` ${alignClass}`}>{title}</h1>
        </div>
    );
};

export default Cenefa;
